import { takeLatest, put, select, call, getContext } from "redux-saga/effects";
import { setDashboardStats, setDashboardStatsError } from "actions/dashboard";
import * as actionTypes from "constants/dashboard/actionTypes";
import { selectAccountId } from "reducers/account/meta";

function* fetchDashboardStats() {
  const auth = yield getContext("auth");
  const token = yield call(auth.getToken);
  const accountId = yield select(selectAccountId);

  try {
    /* global REDIS_READER_URL */
    const response = yield call(
      fetch,
      `${REDIS_READER_URL}?scope=${accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!response.ok) {
      throw new Error("Failed to load dashboard stats from Redis Reader");
    }
    const stats = yield call([response, response.json]);
    return yield put(setDashboardStats({ stats }));
  } catch (e) {
    return yield put(
      setDashboardStatsError({
        errorMessage: e.message
      })
    );
  }
}

export default function* dashboardSagas() {
  yield takeLatest(actionTypes.FETCH_DASHBOARD_STATS, fetchDashboardStats);
}
